import React, { useEffect, useMemo, useState } from 'react';
import SearchAndSelect from '../../../../components/generic/search/SearchAndSelect';
import { useReadMemory } from '../../../generic/hooks/useReadMemory';
import MemoryType from '../../../../service/memory/enum/MemoryType';
import { useRecoilValue } from 'recoil';
import { currentConfiguration } from '../../../../service/memory/recoil/configurationstore';
import ConfigurationConstants from '../../../utils/configurationconstants';
import IntentType from '../../../../intentexecutor/utils/IntentType';
import SelectedProfileCard from '../../../../components/generic/cards/SelectedProfileCard';
import moment from 'moment';
import { getFullName } from '../../../careprovider/visits/utils';
import { getContext } from '../../../../intentexecutor/contextcreator/ContextCreator';
import { teamList } from '../../../../components/recoil/teamsRecoil';
import { mapIntentToRequest } from '../../../../service/network/RequestMapper';
import { getApiUrl } from '../../../../service/network/UrlMapper';
import { performPostRequest } from '../../../../service/network/NetworkService';

const SelectPatientName = ({ patientName, setPatientName, showCancel }) => {
  const userJson = useReadMemory(MemoryType.USER);
  const teams = useRecoilValue(teamList);
  const configuration = useRecoilValue(currentConfiguration);
  const secretKey = configuration[ConfigurationConstants.NIRAMAYA_ORGANIZATION_SECRETKEY];
  const [showDefaultPatientName, setShowDefaultPatientName] = useState(patientName ? true : false);

  const context = useMemo(() => {
    const base = getContext();
    const fromWorkforce = Array.isArray(userJson?.teams)
      ? userJson.teams.map((item) => item?.id).filter((id) => id != null)
      : [];
    return {
      ...base,
      teamIds: teams?.length ? base.teamIds : fromWorkforce,
    };
  }, [teams?.length, userJson.teams]);

  const fetchUserList = async (username) => {
    const searchPayload = {
      query: username,
      organizationIdentifier: userJson?.organizationIdentifier,
      secretKey: secretKey?.key,
      activeOnly: true
    };

    const request = mapIntentToRequest(IntentType.SEARCH_PATIENT, searchPayload, context,);
    const urlMapper = getApiUrl();
    const resultJson = await performPostRequest(urlMapper[IntentType.GET_ALL_PATIENTS], JSON.stringify(request),);
    const responseData = await resultJson.json();

    const result = responseData?.patientList?.map(user => (
      {
        label: getFullName(user?.givenName, user?.familyName),
        value: JSON.stringify(user),
        misc: user?.birthDate ? `MRN: ${user.medicalRecordNumber} | DOB: ${moment(user?.birthDate)?.format('MMM D, YYYY')}` : `MRN: ${user.medicalRecordNumber}`,
      }
    ))
    return result;
  }

  const handleUnselectItems = () => {
    setShowDefaultPatientName(false);
    setPatientName([]);
  }

  useEffect(() => {
    if (patientName.length === 0)
      setShowDefaultPatientName(false);
    else
      setShowDefaultPatientName(true);
  }, [patientName]);

  useEffect(() => {
    if (typeof patientName?.label === "object") {
      setPatientName({
        label: patientName?.label?.props?.children?.props?.title,
        value: patientName?.value,
        givenName: JSON.parse(patientName?.value || "{}")?.givenName,
        familyName: JSON.parse(patientName?.value || "{}")?.familyName,
        misc: patientName?.label?.props?.children?.props?.description,
      });
      setShowDefaultPatientName(true);
    }
  }, [patientName]);

  return (
    <div className='section-one'>
      <span className='section-one-header'>Patient Name</span>
      {showDefaultPatientName ? (
        <SelectedProfileCard selectedItems={patientName} handleUnselectItems={handleUnselectItems} showCancel={showCancel} />
        ) : (
          <SearchAndSelect 
            showSearch
            selectedValues={patientName}
            placeholder="Search Patient"
            fetchOptions={fetchUserList}
            setValue={setPatientName}
            style={{
              width: '100%',
            }}
            selectOptionType="Info"
          />
        )
      }
    </div>
  )
}

export default SelectPatientName;